export const TZ = "Asia/Baghdad";
const loc = (lang: string) => (lang === "ar" ? "ar-IQ-u-nu-latn" : "en-GB");

// 12-hour clock everywhere; Arabic gets full "صباحاً / مساءً"
export const periodAr = (s: string) => s.replace(/(\d)\s?ص(?![\u0600-\u06FF])/g, "$1 صباحاً").replace(/(\d)\s?م(?![\u0600-\u06FF])/g, "$1 مساءً");
const h12 = (s: string, lang: string) => (lang === "ar" ? periodAr(s) : s.replace(/\b(am|pm)\b/g, (x) => x.toUpperCase()));

export const fmtDateTime = (iso: string, lang: string, opts: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" }) =>
  h12(new Date(iso).toLocaleString(loc(lang), { timeZone: TZ, hourCycle: "h12", ...opts, ...(opts.hour ? { hour: "numeric" } : {}) }), lang);

export const fmtDate = (iso: string, lang: string) => new Date(iso).toLocaleDateString(loc(lang), { timeZone: TZ, day: "numeric", month: "short", year: "numeric" });

export const fmtTime = (iso: string, lang: string) => h12(new Date(iso).toLocaleTimeString(loc(lang), { timeZone: TZ, hour: "numeric", minute: "2-digit", hourCycle: "h12" }), lang);

export const fmtClock = (hhmm: string, lang: string) => {
  const [h, m] = hhmm.split(":").map(Number);
  const pm = h >= 12;
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${lang === "ar" ? (pm ? "مساءً" : "صباحاً") : pm ? "PM" : "AM"}`;
};

export const fmtDay = (ymd: string, lang: string) => (ymd ? fmtDate(`${ymd.slice(0, 10)}T12:00:00+03:00`, lang) : "");

export const todayInBaghdad = () => new Date().toLocaleDateString("en-CA", { timeZone: TZ });
